<div (click)="onClick()" [routerLink]="reactive ? ['/dashboard'] : []" class="clickable">
  <img alt="ID37 Logo" class="icon-svg" src="assets/images/ID37_Logo_96x96.svg"/>
</div>
